import component from './component';
import { compose } from 'react-recompose';
import { connect } from 'react-redux';
import moment from '../../common/Moment';
import { get, isNil } from 'lodash';
import Discover from '../../common/redux/actions/DiscoverActions';
import { ACCOUNT_SELECTORS } from '../../common/redux/selectors/AccountSelectors';
import { VIZ_SELECTORS } from '../../common/redux/selectors/viz-selectors';

const mapStateToProps = state => {
  const rawDiscovery =
    state.discover.openDiscoveries[state.discover.displayDiscovery];
  const open = rawDiscovery?.present;
  const { viz } = open ?? {};
  let { updatedOn } = open ?? {};
  // Overwrite if latest update info is available
  if (!isNil(rawDiscovery?.viz?.updatedOn)) {
    updatedOn = rawDiscovery?.viz?.updatedOn;
  }
  const { dateTimeFormat } = ACCOUNT_SELECTORS.getDatetimeFormats(state);
  const dataset = VIZ_SELECTORS.getActiveDataset(state);

  return {
    datasetName: dataset?.name ?? '',
    discoveryId: viz.id,
    newDiscovery: viz.id.includes('newViz'),
    canUpdate: viz.canUpdate,
    name: viz.name,
    creatorName: viz.creatorName,
    updatedOn: moment(updatedOn).format(dateTimeFormat),
    description: get(viz, 'options.description', ''),
    tags: viz.tags,
    revisionSelected: get(open, 'revisionSelected', {}),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    changeDiscoveryName: (discoveryId, value) => {
      dispatch(Discover.changeDiscoveryName(discoveryId, value));
    },
    setSettingForViz: (discoveryId, key, value) => {
      dispatch(
        Discover.setSettingForViz({ id: discoveryId, setting: key, value }),
      );
    },
    changeDiscoveryTags: (discoveryId, tags) => {
      dispatch(Discover.setTagsForViz(discoveryId, tags));
    },
  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(component);
